const Roles = {
  default: "user",
  admin: "admin"
};

export default Roles;
